import api from '../services/api';
import { getSiteId } from '../siteId/siteId';

const SITES_V2_ORDER_METADATA_URL = '/sites/v2/orderMetadata';
const SITE_SHIPPING_CONFIGURATIONS_V2_URL = '/siteShippingConfigurations/v2';
const CLIENTS_V2_URL = '/clients/v2';
const DIVISIONS_V2_URL = '/divisions/v2';

const checkoutService = {
    getOrderMetadataOptions,
    getSiteShippingConfiguration,
    getClients,
    getDivisions,
    getDivision,
};

export default checkoutService;

function getOrderMetadataOptions () {
    const requestConfig = {
        url: SITES_V2_ORDER_METADATA_URL,
        method: 'GET',
        params: {
            siteId: getSiteId(),
        },
    };

    return api(requestConfig);
}

function getSiteShippingConfiguration () {
    const requestConfig = {
        url: SITE_SHIPPING_CONFIGURATIONS_V2_URL,
        method: 'GET',
        params: {
            siteId: getSiteId(),
        },
    };

    return api(requestConfig);
}

function getClients () {
    const requestConfig = {
        url: CLIENTS_V2_URL,
        method: 'GET',
        params: {
            siteId: getSiteId(),
        },
    };

    return api(requestConfig);
}

function getDivisions (userId, { active = true, validateAddress = true } = {}) {
    const requestConfig = {
        url: DIVISIONS_V2_URL,
        method: 'GET',
        params: {
            siteId: getSiteId(),
            userId,
            active,
            validateAddress,
        },
    };

    return api(requestConfig);
}

function getDivision (divisionId) {
    const requestConfig = {
        url: `${DIVISIONS_V2_URL}/${divisionId}`,
        method: 'GET',
    };

    return api(requestConfig);
}
